import React from 'react';
import { Typography, Box, useTheme } from '@mui/material';
import { motion } from 'framer-motion';

const PageHeader = ({ title, subtitle, inView = false, mb = 6 }) => {
  const theme = useTheme();

  const motionProps = inView
    ? {
        initial: { opacity: 0, y: -20 },
        whileInView: { opacity: 1, y: 0 },
        viewport: { once: true, margin: '-60px' },
        transition: { duration: 0.6 },
      }
    : {
        initial: { opacity: 0, y: -20 },
        animate: { opacity: 1, y: 0 },
        transition: { duration: 0.6 },
      };

  return (
    <Box component={motion.div} {...motionProps} sx={{ textAlign: 'center', mb }}>
      <Typography
        variant="h2"
        gutterBottom
        sx={{ color: theme.palette.text.primary, fontWeight: 700 }}
      >
        {title}
      </Typography>
      <Box
        sx={{
          width: 48,
          height: 3,
          bgcolor: theme.palette.primary.main,
          mx: 'auto',
          mt: 0.5,
          borderRadius: 1.5,
        }}
      />
      {subtitle && (
        <Typography variant="body1" sx={{ color: theme.palette.text.secondary, mt: 2, px: { xs: 1, sm: 0 }, maxWidth: 680, mx: 'auto' }}>
          {subtitle}
        </Typography>
      )}
    </Box>
  );
};

export default PageHeader;
